import React, {
  ReactElement, useCallback, useMemo, useState,
} from 'react';
import CurrentUserDetail from '../../model/currentuser/CurrentUserDetail';
import UserContext, { UserContextContent } from './UserContext';
import { useClient } from '../ClientStatusContext';
import { fetchCurrentPouzivatelWithLp } from '../../client/currentUserClient';
import LegislationProcessInfo from '../../model/currentuser/LegislationProcessInfo';
import CurrentUserWithLp from '../../model/currentuser/CurrentUserWithLp';

interface Props {
  children: ReactElement;
}

const UserContextProvider = ({ children }: Props): ReactElement => {
  const [pouzivatel, setPouzivatel] = useState<CurrentUserDetail>(null);
  const [legislationProcess, setLegislationProcess] = useState<LegislationProcessInfo>(null);
  const loginSuccess = useCallback((userWithProcess: CurrentUserWithLp): void => {
    setPouzivatel(userWithProcess.user);
    setLegislationProcess(userWithProcess.legislationProcess);
  }, []);

  const { wrapClient, status } = useClient(fetchCurrentPouzivatelWithLp);
  const fetchProfile = useCallback((type: string, year: number, index: number): void => {
    wrapClient(type, year, index)
      .then(({ data }) => loginSuccess(data));
  }, [loginSuccess, wrapClient]);

  const value: UserContextContent = useMemo(() => ({
    pouzivatel,
    legislationProcess,
    status,
    fetchProfile,
  }), [fetchProfile, legislationProcess, pouzivatel, status]);

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;
